export const TooltipInfoIcon = () => (
  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#AA46DA" height="20" rx="10" width="20" />
    <path
      d="M8.45295 17.2012V7.09021H11.636V17.2012H8.45295ZM10.0549 5.69632C9.55559 5.69632 9.1395 5.52988 8.80663 5.19701C8.48763 4.85027 8.32812 4.43418 8.32812 3.94874C8.32812 3.44944 8.48763 3.03335 8.80663 2.70048C9.1395 2.36761 9.55559 2.20117 10.0549 2.20117C10.5542 2.20117 10.9634 2.36761 11.2824 2.70048C11.6014 3.03335 11.7609 3.44944 11.7609 3.94874C11.7609 4.43418 11.6014 4.85027 11.2824 5.19701C10.9634 5.52988 10.5542 5.69632 10.0549 5.69632Z"
      fill="white"
    />
  </svg>
);
